/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiKeycloakAddAdminClientRoleMappingsToUserPost$Json } from '../fn/keycloak/api-keycloak-add-admin-client-role-mappings-to-user-post-json';
import { ApiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Params } from '../fn/keycloak/api-keycloak-add-admin-client-role-mappings-to-user-post-json';
import { apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain } from '../fn/keycloak/api-keycloak-add-admin-client-role-mappings-to-user-post-plain';
import { ApiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Params } from '../fn/keycloak/api-keycloak-add-admin-client-role-mappings-to-user-post-plain';
import { apiKeycloakCreateMemberUserPost$Json } from '../fn/keycloak/api-keycloak-create-member-user-post-json';
import { ApiKeycloakCreateMemberUserPost$Json$Params } from '../fn/keycloak/api-keycloak-create-member-user-post-json';
import { apiKeycloakCreateMemberUserPost$Plain } from '../fn/keycloak/api-keycloak-create-member-user-post-plain';
import { ApiKeycloakCreateMemberUserPost$Plain$Params } from '../fn/keycloak/api-keycloak-create-member-user-post-plain';
import { apiKeycloakCreateUserPost$Json } from '../fn/keycloak/api-keycloak-create-user-post-json';
import { ApiKeycloakCreateUserPost$Json$Params } from '../fn/keycloak/api-keycloak-create-user-post-json';
import { apiKeycloakCreateUserPost$Plain } from '../fn/keycloak/api-keycloak-create-user-post-plain';
import { ApiKeycloakCreateUserPost$Plain$Params } from '../fn/keycloak/api-keycloak-create-user-post-plain';
import { apiKeycloakFixUserRolesGet } from '../fn/keycloak/api-keycloak-fix-user-roles-get';
import { ApiKeycloakFixUserRolesGet$Params } from '../fn/keycloak/api-keycloak-fix-user-roles-get';
import { apiKeycloakGetAdminClientRoleMappingsForUserGet$Json } from '../fn/keycloak/api-keycloak-get-admin-client-role-mappings-for-user-get-json';
import { ApiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Params } from '../fn/keycloak/api-keycloak-get-admin-client-role-mappings-for-user-get-json';
import { apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain } from '../fn/keycloak/api-keycloak-get-admin-client-role-mappings-for-user-get-plain';
import { ApiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-admin-client-role-mappings-for-user-get-plain';
import { apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json } from '../fn/keycloak/api-keycloak-get-available-client-role-mappings-for-user-get-json';
import { ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Params } from '../fn/keycloak/api-keycloak-get-available-client-role-mappings-for-user-get-json';
import { apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain } from '../fn/keycloak/api-keycloak-get-available-client-role-mappings-for-user-get-plain';
import { ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-available-client-role-mappings-for-user-get-plain';
import { apiKeycloakGetClientsGet$Json } from '../fn/keycloak/api-keycloak-get-clients-get-json';
import { ApiKeycloakGetClientsGet$Json$Params } from '../fn/keycloak/api-keycloak-get-clients-get-json';
import { apiKeycloakGetClientsGet$Plain } from '../fn/keycloak/api-keycloak-get-clients-get-plain';
import { ApiKeycloakGetClientsGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-clients-get-plain';
import { apiKeycloakGetEntityRolesGet$Json } from '../fn/keycloak/api-keycloak-get-entity-roles-get-json';
import { ApiKeycloakGetEntityRolesGet$Json$Params } from '../fn/keycloak/api-keycloak-get-entity-roles-get-json';
import { apiKeycloakGetEntityRolesGet$Plain } from '../fn/keycloak/api-keycloak-get-entity-roles-get-plain';
import { ApiKeycloakGetEntityRolesGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-entity-roles-get-plain';
import { apiKeycloakGetMemberRegistrationSequenceGet$Json } from '../fn/keycloak/api-keycloak-get-member-registration-sequence-get-json';
import { ApiKeycloakGetMemberRegistrationSequenceGet$Json$Params } from '../fn/keycloak/api-keycloak-get-member-registration-sequence-get-json';
import { apiKeycloakGetMemberRegistrationSequenceGet$Plain } from '../fn/keycloak/api-keycloak-get-member-registration-sequence-get-plain';
import { ApiKeycloakGetMemberRegistrationSequenceGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-member-registration-sequence-get-plain';
import { apiKeycloakGetRequiredActionsGet$Json } from '../fn/keycloak/api-keycloak-get-required-actions-get-json';
import { ApiKeycloakGetRequiredActionsGet$Json$Params } from '../fn/keycloak/api-keycloak-get-required-actions-get-json';
import { apiKeycloakGetRequiredActionsGet$Plain } from '../fn/keycloak/api-keycloak-get-required-actions-get-plain';
import { ApiKeycloakGetRequiredActionsGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-required-actions-get-plain';
import { apiKeycloakGetUserGet$Json } from '../fn/keycloak/api-keycloak-get-user-get-json';
import { ApiKeycloakGetUserGet$Json$Params } from '../fn/keycloak/api-keycloak-get-user-get-json';
import { apiKeycloakGetUserGet$Plain } from '../fn/keycloak/api-keycloak-get-user-get-plain';
import { ApiKeycloakGetUserGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-user-get-plain';
import { apiKeycloakGetUserMembersGet$Json } from '../fn/keycloak/api-keycloak-get-user-members-get-json';
import { ApiKeycloakGetUserMembersGet$Json$Params } from '../fn/keycloak/api-keycloak-get-user-members-get-json';
import { apiKeycloakGetUserMembersGet$Plain } from '../fn/keycloak/api-keycloak-get-user-members-get-plain';
import { ApiKeycloakGetUserMembersGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-user-members-get-plain';
import { apiKeycloakGetUserProfileGet$Json } from '../fn/keycloak/api-keycloak-get-user-profile-get-json';
import { ApiKeycloakGetUserProfileGet$Json$Params } from '../fn/keycloak/api-keycloak-get-user-profile-get-json';
import { apiKeycloakGetUserProfileGet$Plain } from '../fn/keycloak/api-keycloak-get-user-profile-get-plain';
import { ApiKeycloakGetUserProfileGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-user-profile-get-plain';
import { apiKeycloakGetUsersCountGet$Json } from '../fn/keycloak/api-keycloak-get-users-count-get-json';
import { ApiKeycloakGetUsersCountGet$Json$Params } from '../fn/keycloak/api-keycloak-get-users-count-get-json';
import { apiKeycloakGetUsersCountGet$Plain } from '../fn/keycloak/api-keycloak-get-users-count-get-plain';
import { ApiKeycloakGetUsersCountGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-users-count-get-plain';
import { apiKeycloakGetUsersGet$Json } from '../fn/keycloak/api-keycloak-get-users-get-json';
import { ApiKeycloakGetUsersGet$Json$Params } from '../fn/keycloak/api-keycloak-get-users-get-json';
import { apiKeycloakGetUsersGet$Plain } from '../fn/keycloak/api-keycloak-get-users-get-plain';
import { ApiKeycloakGetUsersGet$Plain$Params } from '../fn/keycloak/api-keycloak-get-users-get-plain';
import { apiKeycloakMigrateRolesGet } from '../fn/keycloak/api-keycloak-migrate-roles-get';
import { ApiKeycloakMigrateRolesGet$Params } from '../fn/keycloak/api-keycloak-migrate-roles-get';
import { apiKeycloakSetUserPasswordGet$Json } from '../fn/keycloak/api-keycloak-set-user-password-get-json';
import { ApiKeycloakSetUserPasswordGet$Json$Params } from '../fn/keycloak/api-keycloak-set-user-password-get-json';
import { apiKeycloakSetUserPasswordGet$Plain } from '../fn/keycloak/api-keycloak-set-user-password-get-plain';
import { ApiKeycloakSetUserPasswordGet$Plain$Params } from '../fn/keycloak/api-keycloak-set-user-password-get-plain';
import { apiKeycloakUpdateUserPost$Json } from '../fn/keycloak/api-keycloak-update-user-post-json';
import { ApiKeycloakUpdateUserPost$Json$Params } from '../fn/keycloak/api-keycloak-update-user-post-json';
import { apiKeycloakUpdateUserPost$Plain } from '../fn/keycloak/api-keycloak-update-user-post-plain';
import { ApiKeycloakUpdateUserPost$Plain$Params } from '../fn/keycloak/api-keycloak-update-user-post-plain';
import { Client } from '../models/client';
import { EntityUser } from '../models/entity-user';
import { RequiredActionProvider } from '../models/required-action-provider';
import { Response } from '../models/response';
import { Role } from '../models/role';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class KeycloakService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiKeycloakGetEntityRolesGet()` */
  static readonly ApiKeycloakGetEntityRolesGetPath = '/api/keycloak/GetEntityRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetEntityRolesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetEntityRolesGet$Plain$Response(params?: ApiKeycloakGetEntityRolesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return apiKeycloakGetEntityRolesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetEntityRolesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetEntityRolesGet$Plain(params?: ApiKeycloakGetEntityRolesGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.apiKeycloakGetEntityRolesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetEntityRolesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetEntityRolesGet$Json$Response(params?: ApiKeycloakGetEntityRolesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return apiKeycloakGetEntityRolesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetEntityRolesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetEntityRolesGet$Json(params?: ApiKeycloakGetEntityRolesGet$Json$Params, context?: HttpContext): Observable<Array<string>> {
    return this.apiKeycloakGetEntityRolesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetMemberRegistrationSequenceGet()` */
  static readonly ApiKeycloakGetMemberRegistrationSequenceGetPath = '/api/keycloak/GetMemberRegistrationSequence';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetMemberRegistrationSequenceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetMemberRegistrationSequenceGet$Plain$Response(params?: ApiKeycloakGetMemberRegistrationSequenceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiKeycloakGetMemberRegistrationSequenceGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetMemberRegistrationSequenceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetMemberRegistrationSequenceGet$Plain(params?: ApiKeycloakGetMemberRegistrationSequenceGet$Plain$Params, context?: HttpContext): Observable<string> {
    return this.apiKeycloakGetMemberRegistrationSequenceGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetMemberRegistrationSequenceGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetMemberRegistrationSequenceGet$Json$Response(params?: ApiKeycloakGetMemberRegistrationSequenceGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiKeycloakGetMemberRegistrationSequenceGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetMemberRegistrationSequenceGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetMemberRegistrationSequenceGet$Json(params?: ApiKeycloakGetMemberRegistrationSequenceGet$Json$Params, context?: HttpContext): Observable<string> {
    return this.apiKeycloakGetMemberRegistrationSequenceGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetUsersGet()` */
  static readonly ApiKeycloakGetUsersGetPath = '/api/keycloak/GetUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUsersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersGet$Plain$Response(params?: ApiKeycloakGetUsersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EntityUser>>> {
    return apiKeycloakGetUsersGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUsersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersGet$Plain(params?: ApiKeycloakGetUsersGet$Plain$Params, context?: HttpContext): Observable<Array<EntityUser>> {
    return this.apiKeycloakGetUsersGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EntityUser>>): Array<EntityUser> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUsersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersGet$Json$Response(params?: ApiKeycloakGetUsersGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EntityUser>>> {
    return apiKeycloakGetUsersGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUsersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersGet$Json(params?: ApiKeycloakGetUsersGet$Json$Params, context?: HttpContext): Observable<Array<EntityUser>> {
    return this.apiKeycloakGetUsersGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EntityUser>>): Array<EntityUser> => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetUserMembersGet()` */
  static readonly ApiKeycloakGetUserMembersGetPath = '/api/keycloak/GetUserMembers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserMembersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserMembersGet$Plain$Response(params?: ApiKeycloakGetUserMembersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EntityUser>>> {
    return apiKeycloakGetUserMembersGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserMembersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserMembersGet$Plain(params?: ApiKeycloakGetUserMembersGet$Plain$Params, context?: HttpContext): Observable<Array<EntityUser>> {
    return this.apiKeycloakGetUserMembersGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EntityUser>>): Array<EntityUser> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserMembersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserMembersGet$Json$Response(params?: ApiKeycloakGetUserMembersGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EntityUser>>> {
    return apiKeycloakGetUserMembersGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserMembersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserMembersGet$Json(params?: ApiKeycloakGetUserMembersGet$Json$Params, context?: HttpContext): Observable<Array<EntityUser>> {
    return this.apiKeycloakGetUserMembersGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EntityUser>>): Array<EntityUser> => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetUserGet()` */
  static readonly ApiKeycloakGetUserGetPath = '/api/keycloak/GetUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserGet$Plain$Response(params?: ApiKeycloakGetUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EntityUser>> {
    return apiKeycloakGetUserGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserGet$Plain(params?: ApiKeycloakGetUserGet$Plain$Params, context?: HttpContext): Observable<EntityUser> {
    return this.apiKeycloakGetUserGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<EntityUser>): EntityUser => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserGet$Json$Response(params?: ApiKeycloakGetUserGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EntityUser>> {
    return apiKeycloakGetUserGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserGet$Json(params?: ApiKeycloakGetUserGet$Json$Params, context?: HttpContext): Observable<EntityUser> {
    return this.apiKeycloakGetUserGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<EntityUser>): EntityUser => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetClientsGet()` */
  static readonly ApiKeycloakGetClientsGetPath = '/api/keycloak/GetClients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetClientsGet$Plain$Response(params?: ApiKeycloakGetClientsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Client>>> {
    return apiKeycloakGetClientsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetClientsGet$Plain(params?: ApiKeycloakGetClientsGet$Plain$Params, context?: HttpContext): Observable<Array<Client>> {
    return this.apiKeycloakGetClientsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Client>>): Array<Client> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetClientsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetClientsGet$Json$Response(params?: ApiKeycloakGetClientsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Client>>> {
    return apiKeycloakGetClientsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetClientsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetClientsGet$Json(params?: ApiKeycloakGetClientsGet$Json$Params, context?: HttpContext): Observable<Array<Client>> {
    return this.apiKeycloakGetClientsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Client>>): Array<Client> => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetUsersCountGet()` */
  static readonly ApiKeycloakGetUsersCountGetPath = '/api/keycloak/GetUsersCount';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUsersCountGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersCountGet$Plain$Response(params?: ApiKeycloakGetUsersCountGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiKeycloakGetUsersCountGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUsersCountGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersCountGet$Plain(params?: ApiKeycloakGetUsersCountGet$Plain$Params, context?: HttpContext): Observable<number> {
    return this.apiKeycloakGetUsersCountGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUsersCountGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersCountGet$Json$Response(params?: ApiKeycloakGetUsersCountGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiKeycloakGetUsersCountGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUsersCountGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUsersCountGet$Json(params?: ApiKeycloakGetUsersCountGet$Json$Params, context?: HttpContext): Observable<number> {
    return this.apiKeycloakGetUsersCountGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetRequiredActionsGet()` */
  static readonly ApiKeycloakGetRequiredActionsGetPath = '/api/keycloak/GetRequiredActions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetRequiredActionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetRequiredActionsGet$Plain$Response(params?: ApiKeycloakGetRequiredActionsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RequiredActionProvider>>> {
    return apiKeycloakGetRequiredActionsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetRequiredActionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetRequiredActionsGet$Plain(params?: ApiKeycloakGetRequiredActionsGet$Plain$Params, context?: HttpContext): Observable<Array<RequiredActionProvider>> {
    return this.apiKeycloakGetRequiredActionsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RequiredActionProvider>>): Array<RequiredActionProvider> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetRequiredActionsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetRequiredActionsGet$Json$Response(params?: ApiKeycloakGetRequiredActionsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RequiredActionProvider>>> {
    return apiKeycloakGetRequiredActionsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetRequiredActionsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetRequiredActionsGet$Json(params?: ApiKeycloakGetRequiredActionsGet$Json$Params, context?: HttpContext): Observable<Array<RequiredActionProvider>> {
    return this.apiKeycloakGetRequiredActionsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RequiredActionProvider>>): Array<RequiredActionProvider> => r.body)
    );
  }

  /** Path part for operation `apiKeycloakSetUserPasswordGet()` */
  static readonly ApiKeycloakSetUserPasswordGetPath = '/api/keycloak/SetUserPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakSetUserPasswordGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakSetUserPasswordGet$Plain$Response(params?: ApiKeycloakSetUserPasswordGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return apiKeycloakSetUserPasswordGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakSetUserPasswordGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakSetUserPasswordGet$Plain(params?: ApiKeycloakSetUserPasswordGet$Plain$Params, context?: HttpContext): Observable<boolean> {
    return this.apiKeycloakSetUserPasswordGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakSetUserPasswordGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakSetUserPasswordGet$Json$Response(params?: ApiKeycloakSetUserPasswordGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return apiKeycloakSetUserPasswordGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakSetUserPasswordGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakSetUserPasswordGet$Json(params?: ApiKeycloakSetUserPasswordGet$Json$Params, context?: HttpContext): Observable<boolean> {
    return this.apiKeycloakSetUserPasswordGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetAdminClientRoleMappingsForUserGet()` */
  static readonly ApiKeycloakGetAdminClientRoleMappingsForUserGetPath = '/api/keycloak/GetAdminClientRoleMappingsForUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Response(params?: ApiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Role>>> {
    return apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain(params?: ApiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Params, context?: HttpContext): Observable<Array<Role>> {
    return this.apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Role>>): Array<Role> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetAdminClientRoleMappingsForUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Response(params?: ApiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Role>>> {
    return apiKeycloakGetAdminClientRoleMappingsForUserGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAdminClientRoleMappingsForUserGet$Json(params?: ApiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Params, context?: HttpContext): Observable<Array<Role>> {
    return this.apiKeycloakGetAdminClientRoleMappingsForUserGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Role>>): Array<Role> => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetAvailableClientRoleMappingsForUserGet()` */
  static readonly ApiKeycloakGetAvailableClientRoleMappingsForUserGetPath = '/api/keycloak/GetAvailableClientRoleMappingsForUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Response(params?: ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Role>>> {
    return apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain(params?: ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Params, context?: HttpContext): Observable<Array<Role>> {
    return this.apiKeycloakGetAvailableClientRoleMappingsForUserGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Role>>): Array<Role> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Response(params?: ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Role>>> {
    return apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json(params?: ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Params, context?: HttpContext): Observable<Array<Role>> {
    return this.apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Role>>): Array<Role> => r.body)
    );
  }

  /** Path part for operation `apiKeycloakAddAdminClientRoleMappingsToUserPost()` */
  static readonly ApiKeycloakAddAdminClientRoleMappingsToUserPostPath = '/api/keycloak/AddAdminClientRoleMappingsToUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Response(params?: ApiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain(params?: ApiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Params, context?: HttpContext): Observable<boolean> {
    return this.apiKeycloakAddAdminClientRoleMappingsToUserPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakAddAdminClientRoleMappingsToUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Response(params?: ApiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return apiKeycloakAddAdminClientRoleMappingsToUserPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakAddAdminClientRoleMappingsToUserPost$Json(params?: ApiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Params, context?: HttpContext): Observable<boolean> {
    return this.apiKeycloakAddAdminClientRoleMappingsToUserPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiKeycloakCreateUserPost()` */
  static readonly ApiKeycloakCreateUserPostPath = '/api/keycloak/CreateUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakCreateUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateUserPost$Plain$Response(params?: ApiKeycloakCreateUserPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiKeycloakCreateUserPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakCreateUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateUserPost$Plain(params?: ApiKeycloakCreateUserPost$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiKeycloakCreateUserPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakCreateUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateUserPost$Json$Response(params?: ApiKeycloakCreateUserPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiKeycloakCreateUserPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakCreateUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateUserPost$Json(params?: ApiKeycloakCreateUserPost$Json$Params, context?: HttpContext): Observable<Response> {
    return this.apiKeycloakCreateUserPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiKeycloakCreateMemberUserPost()` */
  static readonly ApiKeycloakCreateMemberUserPostPath = '/api/keycloak/CreateMemberUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakCreateMemberUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateMemberUserPost$Plain$Response(params?: ApiKeycloakCreateMemberUserPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiKeycloakCreateMemberUserPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakCreateMemberUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateMemberUserPost$Plain(params?: ApiKeycloakCreateMemberUserPost$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiKeycloakCreateMemberUserPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakCreateMemberUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateMemberUserPost$Json$Response(params?: ApiKeycloakCreateMemberUserPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiKeycloakCreateMemberUserPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakCreateMemberUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakCreateMemberUserPost$Json(params?: ApiKeycloakCreateMemberUserPost$Json$Params, context?: HttpContext): Observable<Response> {
    return this.apiKeycloakCreateMemberUserPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiKeycloakUpdateUserPost()` */
  static readonly ApiKeycloakUpdateUserPostPath = '/api/keycloak/UpdateUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakUpdateUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakUpdateUserPost$Plain$Response(params?: ApiKeycloakUpdateUserPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiKeycloakUpdateUserPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakUpdateUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakUpdateUserPost$Plain(params?: ApiKeycloakUpdateUserPost$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiKeycloakUpdateUserPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakUpdateUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakUpdateUserPost$Json$Response(params?: ApiKeycloakUpdateUserPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiKeycloakUpdateUserPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakUpdateUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKeycloakUpdateUserPost$Json(params?: ApiKeycloakUpdateUserPost$Json$Params, context?: HttpContext): Observable<Response> {
    return this.apiKeycloakUpdateUserPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiKeycloakMigrateRolesGet()` */
  static readonly ApiKeycloakMigrateRolesGetPath = '/api/keycloak/MigrateRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakMigrateRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakMigrateRolesGet$Response(params?: ApiKeycloakMigrateRolesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiKeycloakMigrateRolesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakMigrateRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakMigrateRolesGet(params?: ApiKeycloakMigrateRolesGet$Params, context?: HttpContext): Observable<void> {
    return this.apiKeycloakMigrateRolesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiKeycloakGetUserProfileGet()` */
  static readonly ApiKeycloakGetUserProfileGetPath = '/api/keycloak/GetUserProfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserProfileGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserProfileGet$Plain$Response(params?: ApiKeycloakGetUserProfileGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return apiKeycloakGetUserProfileGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserProfileGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserProfileGet$Plain(params?: ApiKeycloakGetUserProfileGet$Plain$Params, context?: HttpContext): Observable<User> {
    return this.apiKeycloakGetUserProfileGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakGetUserProfileGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserProfileGet$Json$Response(params?: ApiKeycloakGetUserProfileGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return apiKeycloakGetUserProfileGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakGetUserProfileGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakGetUserProfileGet$Json(params?: ApiKeycloakGetUserProfileGet$Json$Params, context?: HttpContext): Observable<User> {
    return this.apiKeycloakGetUserProfileGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /** Path part for operation `apiKeycloakFixUserRolesGet()` */
  static readonly ApiKeycloakFixUserRolesGetPath = '/api/keycloak/FixUserRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKeycloakFixUserRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakFixUserRolesGet$Response(params?: ApiKeycloakFixUserRolesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiKeycloakFixUserRolesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKeycloakFixUserRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKeycloakFixUserRolesGet(params?: ApiKeycloakFixUserRolesGet$Params, context?: HttpContext): Observable<void> {
    return this.apiKeycloakFixUserRolesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
